export const routes = (prefix = `billing`) => [
    {
        path: `/${prefix}/cancel-unposted-bills/create`,
        name: `${prefix}.cancel-unposted-bills.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.cancel-unposted-bills.create`,
                PageDescription: "Accounts - Cancel Unposted Bills",
            },
        },
    },
];
